
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"17.5","fill":"#3BA8CB","stroke":"#fff","stroke-width":"3"}}),_c('path',{attrs:{"d":"M19 23.485l4.243-4.242a6 6 0 10-8.486 0L19 23.485zm5.657-2.828L19 26.314l-5.657-5.657a8 8 0 1111.314 0zM12 27h14v2H12v-2z","fill":"#fff"}})])
          )
        }
      }
    